// Animation 

var $animation_elements = $('.animatedFadeInUp');
var $window = $(window);

function check_if_in_view() {
  var window_height = $window.height();
  var window_top_position = $window.scrollTop();
  var window_bottom_position = (window_top_position + window_height);

  $.each($animation_elements, function() {
    var $element = $(this);
    var element_height = $element.outerHeight();
    var element_top_position = $element.offset().top;
    var element_bottom_position = (element_top_position + element_height);

    // check to see if this current container is within viewport
    if ((element_bottom_position >= window_top_position) &&
      (element_top_position <= window_bottom_position)) {
      $element.addClass('fadeInUp');
    } else {
      $element.removeClass('fadeInUp');
    }
  });
}

$window.on('scroll resize', check_if_in_view);
$window.trigger('scroll');


// Image with text block 

// function activeContent() {
//   let listItem = document.querySelectorAll('.iwt__item');
//   let section = document.querySelector('.image-with-text-block');
//   if (listItem.length > 0) {
//     let intervalId;
//     let currentActive = listItem[0];
    
//     function startInterval() {
//       intervalId = setInterval(() => {
//         let currentIndex = Array.from(listItem).indexOf(currentActive);
//         let nextIndex = (currentIndex + 1) % listItem.length;
//         currentActive.classList.remove('active');
//         currentActive = listItem[nextIndex];
//         currentActive.classList.add('active');
//       }, 3000);
//     }
    
//     function stopInterval() {
//       clearInterval(intervalId);
//     }
  
//     function checkSectionInView() {
//       let sectionRect = section.getBoundingClientRect();
//       let windowHeight = window.innerHeight;
  
//       if (
//         sectionRect.top >= 0 &&
//         sectionRect.bottom <= windowHeight
//       ) {
//         startInterval();
//       } else {
//         stopInterval();
//       }
//     }
  
//     window.addEventListener('scroll', checkSectionInView);
//     checkSectionInView();
  
//     listItem.forEach((item, index) => {
//       if (document.querySelector('body').offsetWidth > 990) {
//         item.querySelector('h4').addEventListener('mouseover', (e) => {
//           stopInterval();
//           if (item !== currentActive) {
//             currentActive.classList.remove('active');
//             item.classList.add('active');
//             currentActive = item;
//           }
//         }); 
  
//         item.querySelector('h4').addEventListener('mouseout', (e) => {
//           startInterval();
//         }); 
//       } else {
//         item.querySelector('h4').addEventListener('click', (e) => {    
//           item.classList.toggle('active');
//         });        
//       }
//     });    
//   }

// }

// activeContent();


//Logo scroll
(function LogoSlide() {
  let listElem = document.querySelectorAll('.logo-scroll__slider');
  if (listElem) {
    listElem.forEach(( elem ) => {
      let dataItem = elem.getAttribute('data-class');
      let slideItem = document.querySelector(`[data-class=${dataItem}]`);
      let duration = Number(slideItem.getAttribute('data-duration')) / 10;

      // Play with this value to change the speed
      let tickerSpeed = duration;
      if( elem.classList.contains('logo-scroll--left-right')) {
        tickerSpeed = -duration;
      }

      let flickity = null;

      const update = () => {
        if (flickity.slides) {
          flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
          flickity.selectedIndex = flickity.dragEndRestingSelect();
          flickity.updateSelectedSlide();
          flickity.settle(flickity.x);
        }
        window.requestAnimationFrame(update);
      };

      flickity = new Flickity(slideItem, {
        autoPlay: false,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        wrapAround: true,
        selectedAttraction: 0.015,
        friction: 0.25
      });


      if( elem.classList.contains('logo-scroll--left-right')) {
        flickity.x = flickity.slideableWidth;
      } else {
        flickity.x = 0;
      }

      update();
    });    
  }
})();


// Featured blog
(function FeaturedCollectionSlide() {
  let listElem = document.querySelectorAll('.blog__slide--wrap');
  if (listElem) {
    listElem.forEach(( elem ) => {
      let dataItem = elem.getAttribute('data-class');
      let slideItem = document.querySelector(`[data-class=${dataItem}]`);
      if (slideItem) {
        let flkty = new Flickity( slideItem, {
          cellAlign: 'left',
          prevNextButtons: false,
          freeScroll: false,
          contain: true,
          wrapAround: true,
          cellSelector: '.article-card__wrap',
          pageDots: true
        });

      }
    });        
  }
})();

// Flickity fade
(function FlickityFade() {
  let listElem = document.querySelectorAll('.js-slider-fade');
  if (listElem) {
    listElem.forEach(( elem ) => {
      let dataItem = elem.getAttribute('data-class');
      let slideItem = document.querySelector(`[data-class=${dataItem}]`);
      if (slideItem) {
        let flkty = new Flickity( slideItem, {
          cellAlign: 'left',
          prevNextButtons: false,
          freeScroll: false,
          contain: true,
          wrapAround: true,
          pageDots: true,
          fade: true,
        });

      }
    });        
  }
})();


// SliderBase
(function SliderBase() {
  let listSliders = document.querySelectorAll('.js-slider');
  let listSlidersMobile = document.querySelector('.js-slider-mobile');
  if (listSliders) {
    listSliders.forEach((elem) => {
      if (elem) {
        let flkty = new Flickity( elem, {
          cellAlign: 'left',
          prevNextButtons: false,
          freeScroll: false,
          contain: true,
          wrapAround: true,
          pageDots: true,
          adaptiveHeight: true
        });

        let previousWrappedButton = elem.parentElement.querySelector('.button--previous-wrapped');
        previousWrappedButton && previousWrappedButton.addEventListener( 'click', function() {
          flkty.previous( true );
        });

        var NextsWrappedButton = elem.parentElement.querySelector('.button--next-wrapped');
        NextsWrappedButton && NextsWrappedButton.addEventListener( 'click', function() {
          flkty.next( true );
        });
      }
    });        
  }

  if (listSlidersMobile && document.querySelector('body').offsetWidth < 750) {
    let flktyMobile = new Flickity( listSlidersMobile, {
      cellAlign: 'left',
      prevNextButtons: false,
      freeScroll: false,
      contain: true,
      wrapAround: true,
      pageDots: true,
    });
  }
})();


// Counter number 
class CountersNumber extends HTMLElement {
  constructor() {
    super();
    this.counter = this.querySelector('.number__count--up');
    if (this.counter) {
      this.target = this.counter.getAttribute('data-count');      
    }
  }
  
  connectedCallback() {
    this.updateCount();    
  }

  updateCount() {
    let show = false;
    let _this = this;
    let duration;

    if (_this.target < 50 ) {
      duration = 100;
    } else if ( _this.target < 100 ) {
      duration = 50;
    } else {
      duration = 1;
    }

    window.addEventListener("scroll", function() {
      if (_this.counter) {
        var top = _this.counter.getBoundingClientRect().top;
        var bottom = _this.counter.getBoundingClientRect().bottom; 

        if (top < window.innerHeight && bottom > 0 && !show ) {
          show = true;
          var count = 0;
          var interval = setInterval(function() {
            if(_this.target < 1000) {
              count++;
            } else {
              count += 5;
            }
    
            _this.counter.innerHTML = count;
            if (count == _this.target) {
              clearInterval(interval);
            }
          }, duration);
        }
      }
    });

    if (document.querySelector('body').classList.contains('template_blog_our-work')) {
      window.addEventListener("load", function() {
        if (_this.counter) {
          show = true;
          var count = 0;
          var interval = setInterval(function() {
            count++;
            _this.counter.innerHTML = count;
            if (count == _this.target) {
              clearInterval(interval);
            }
          }, duration);
        }
      });      
    }

  }
}

customElements.define('counters-number', CountersNumber);

// Image lazyload
document.addEventListener('DOMContentLoaded', () => {
  const images = document.querySelectorAll('img.lazy');

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const image = entry.target;
        image.src = image.dataset.src;
        observer.unobserve(image);
        image.classList.add("lazy-loaded");
        image.closest('.article__image').classList.add('article__image--lazy-loaded');
      }
    });
  }, {
    threshold: 0.5
  });
  
  images.forEach(image => {
    observer.observe(image);
  });
});


// Contact Us 
(function CheckOption(params) {
  let options = document.querySelectorAll('.field__select option');
  let href = location.href;

  options.forEach(option => {
    let value = option.value;
    if ( href.includes(value) ) {
      document.querySelector('.field__select select').value = value;
    }
  })
})();


// Work details read next
(function ChangePositionPagination() {
  let blogWork = document.querySelector('.related__blog_work');
  if (blogWork) {
    let mainWrap = blogWork.closest('main');
    mainWrap.appendChild(blogWork);
  }
})();


//Button read more mobile of section multicolum custom
// class ReadMore extends HTMLElement {
//   constructor() {
//     super();
//     this.button = this.querySelector('button');
//     this.content = this.querySelector('.multicolumn-card__text *');
//     this.contentHeight = this.content.clientHeight;
//     this.lineHeight = parseInt(window.getComputedStyle(this.content).lineHeight);
//     this.lineCount = Math.floor(this.contentHeight / this.lineHeight);
//     if (this.lineCount ) {
//       this.content.style.display = '-webkit-box';
//       this.button.style.display = 'block'
//     }

//     if (this.button.style.display === 'block' ) {
//       this.button.addEventListener('click', this.handleButtonReadMore.bind(this));      
//     }
//   }
  
//   handleButtonReadMore() {
//     if (this.content.style.display === '-webkit-box' ) {
//       this.content.style.display = 'block';
//       this.button.innerText = 'Read less';
//     } else {
//       this.content.style.display = '-webkit-box';      
//       this.button.innerText = 'Read more';
//     }
//   }
// }

// customElements.define('multicolumn-card', ReadMore);